<script setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import AssumptiveInput from "./AssumptiveInput.vue";
import ProductPieces from "./ProductPieces.vue";

const store = useStore();

const topItems = computed(() => store.getters["product/topItems"]);
const fastestItems = computed(() => store.getters["product/fastestItems"]);
const trending = computed(() => store.getters["product/trending"]);

const isLoadingProducts = computed(() => store.getters["loading/fetchProducts"]);
const showAssumptiveInput = ref(false); // hidden in PRINT-691, remove completely if not reverted after sale
</script>

<template>
  <div class="products">
    <AssumptiveInput v-if="showAssumptiveInput" />
    <div v-if="isLoadingProducts" class="products__loading">
      In the meantime give us more information
      <br />
      about your project...
    </div>
    <ProductPieces :products="topItems" :section-context="'fastest_delivery_tshirts'">
      Super Fast Delivery T-Shirts
    </ProductPieces>
    <ProductPieces :products="fastestItems" :section-context="'fastest_delivery_sweatshirts'">
      Super Fast Delivery Sweatshirts
    </ProductPieces>
    <ProductPieces :products="trending" :section-context="'trending_products'">
      Trending Products
    </ProductPieces>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/pod/settings";

.products {
  &__loading {
    margin: 16px;
    font-size: 11px;
    font-weight: 400;
    color: $digital-assets-gray-modern-700;
    text-align: center;
  }
}
</style>
